// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__rlEDU","inner":"Footer_inner__323lf"};